
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {map} from 'rxjs/operators';
import { Bank, NetBanking, ZestBank, RecommendedBank, RecommendedBankList } from './contracts/bank';
import { Statement } from './contracts/statement';
import { ApplicationService } from '../../application/application.service';
import { BackendService } from '../../backend.service';

@Injectable()
export class StatementsService {

  private recommendedBankList: RecommendedBank[] = RecommendedBankList;
  private bankOptionsUrl = '/zestlife/Customers/{customerId}/SupportedBankList?merchantId={merchantId}';
  private getBankListUrl = '/perfios/ZestUpload/api/v1/BanksList';
  private getNetBankingApiUrl = '/perfios/ZestUpload/api/v1/{customerId}/netbankingfetch';
  private saveStatementUrl = '/perfios/ZestUpload/api/v1/{customerId}/statement/upload';
  private getStatementUrl = '/perfios/ZestUpload/api/v1/{customerId}/getBankDocumentDetails';
  private deleteStatementUrl = '/perfios/ZestUpload/api/v1/{customerId}/{f}/{e}';
  private bankStatementCompleteUrl = '/perfios/ZestUpload/api/v1/{customerId}/statement/complete';
  private checkNetBankingStatusUrl = '/perfios/ZestUpload/api/v1/{customerId}/{zestTxId}/updateNBStatus?merchantId={merchantId}';
  private checkPerfiosReportAvailable = '/perfios/ZestUpload/api/v1/{customerId}/reportAvailable';
  private checkMerchantTypeUrl = '/application_flow/api/v1/MerchantSettings/{merchantId}';
  private setOtherBankSelectedUrl = '/documents/statementUpload/customer/otherBankSelected';
  private perfiosFaqsUrl = '/iv/perfiosFaqs.json';
  private learnMoreUrl = '/iv/{method}/{bankId}-learnMore.json';

  constructor(private backendService: BackendService, private applicationService: ApplicationService) { }

  getBanks(merchantId): Observable<Bank[]> {
    return this.backendService.getData(this.bankOptionsUrl.replace('{merchantId}', merchantId));
  }
  getBankList(): Observable<ZestBank[]> {
    return this.backendService.getData(this.getBankListUrl);
  }
  getNetbankingApi(email: string, returnUrl: string, applicationId: string, bankId: string): Observable<NetBanking> {
    const netBankingdata = {
      'emailId': email,
      'returnUrl': returnUrl,
      'applicationId': applicationId,
      'bankId': bankId,
      'merchantIdSource': this.applicationService.getMerchantId()
    };
    return this.backendService.setData(this.getNetBankingApiUrl.replace('{bankId}', bankId), netBankingdata);
  }
  getPerfiosReport() {
    return this.backendService.getData(this.checkPerfiosReportAvailable);
  }
  getNetbankingStatus(netbankingId) {
    let url = this.checkNetBankingStatusUrl;
    if (this.applicationService.getMerchantId()) {
      const merchantId = this.applicationService.getMerchantId();
      url = this.checkNetBankingStatusUrl.replace('{merchantId}', merchantId);
    } else {
      url = this.checkNetBankingStatusUrl.replace('{merchantId}', '');
    }
    return this.backendService.getData(url.replace('{zestTxId}', netbankingId));
  }
  uploadStatement(postData) {
    return this.backendService.setData(this.saveStatementUrl, postData);
  }
  getStatements(): Observable<Statement> {
    return this.backendService.getData(this.getStatementUrl).pipe(map(response => {
      const res = response;
      const statement = new Statement(res.apiType, res.errorMessage, res.transactionState, res.uploadedFileNames, 2);
      return statement;
    }));
  }
  setStatementTransationComplete(applicationId, bankId) {
    const statementData = {
      'applicationId': applicationId,
      'bankId': bankId
    };
    return this.backendService.setData(this.bankStatementCompleteUrl, statementData);
  }
  deleteStatement(f, e) {
    f = f.replace(/\.[^/.]+$/, '');
    let url = this.deleteStatementUrl.replace('{f}', f);
    url = url.replace('{e}', e);
    return this.backendService.deleteData(url);
  }
  getRecommendedBanks(): RecommendedBank[] {
    return this.recommendedBankList;
  }
  checkMerchantType(merchantId) {
    return this.backendService.getData(this.checkMerchantTypeUrl.replace('{merchantId}', merchantId));
  }
  setOtherBankSelected(customerId: string, applicationId: string, merchantId: string) {
    const otherBankSelectedData = {
      'customerId': customerId,
      'applicationId': applicationId,
      'merchantId': merchantId
    };
    return this.backendService.setData(this.setOtherBankSelectedUrl, otherBankSelectedData);
  }
  getFaqs() {
    return this.backendService.getData(this.perfiosFaqsUrl, null, false, true, true);
  }
  getLearnMoreContent(method: string, bankId?: string) {
    let url = this.learnMoreUrl.replace('{method}', method.toLowerCase());
    url = bankId ? url.replace('{bankId}', bankId.toLowerCase()) : url.replace('{bankId}', 'default');
    return this.backendService.getData(url, null, false, true, true);
  }
}
